export const screens = {
  ENTER_EMAIL: 'ENTER_EMAIL',
  ENTER_OTP: 'ENTER_OTP',
  RESET_PIN: 'RESET_PIN'
}
